import { getprofile } from '@api/authentication';
import { generateOtp } from '@api/verification';
import { TIdentity, TOtp } from '@components/types';
import { profileState } from '@recoil/atoms';
import { Button, Modal } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react'
import Countdown from 'react-countdown';
import { useRecoilState } from 'recoil';

interface Props {
    showModal?: boolean;
    setShowModal?: Function;
    ActionFun?: Function;
    closeFunction?: Function;
    otp?: number;
    setOtp?: Function;
    retryfunction?: Function;
    phone?: string;
    message?: string;
}

const OtpModal: React.FC<Props> = ({ showModal, setShowModal, ActionFun, closeFunction, otp, setOtp, retryfunction, phone, message }) => {
    const [code, setcode] = useState(new Array(6).fill(""));
    const router = useRouter();
    // const [message, setMessage] = useState("");
    const [resend, setResend] = useState(true);

    const handleChange = (element: any, index: number) => {
        if (isNaN(element.value)) return false;
        setcode([...code.map((d, indx) => (indx === index ? element.value : d))]);
        if (element.nextSibling) {
            element.nextSibling.focus();
        }
    };

    useEffect(() => {
        setOtp(code.join(''))
    }, [code])


    const renderer = ({ seconds, completed }: any) => {
        if (completed) {
            setResend(false);
        } else {
            return (
                <span>
                    {"00"}:{seconds}
                </span>
            );
        }
    };



    return (
        <Modal
            title={null}
            open={showModal}
            footer={null}
            maskClosable={false}
            onCancel={() => closeFunction()}
            bodyStyle={{
                padding: "12px",
                maxWidth: "100%",
                overflowX: "hidden",
            }}
        >
            <div className="flex flex-col gap-2 font-manrope max-w-full overflow-hidden">
                <div className="font-bold text-sm md:text-base text-neutral-700">
                    Verify OTP
                </div>

                <div className="grid gap-2">
                    <span className="flex justify-center text-neutral-900 font-semibold">
                        We have sent an OTP to
                    </span>
                    <span className="flex justify-center text-neutral-900 font-bold text-xl">
                        +91{phone}
                    </span>
                    <div className="flex gap-1 items-center justify-center text-neutral-400 text-sm flex-wrap">
                        Not yours?
                        <span
                            className="text-brand-500 font-semibold cursor-pointer"
                            onClick={() => closeFunction()}
                        >
                            Change Mobile Number
                        </span>
                    </div>
                </div>

                <div className="grid gap-4 justify-center md:p-4 py-4 px-2 max-w-full">
                    <div className="flex justify-center text-neutral-900">
                        Enter OTP
                    </div>

                    <div className="flex justify-center md:gap-3 gap-2 flex-wrap max-w-full">
                        {code?.map((data, index) => (
                            <input
                                key={index}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="
                            border border-black rounded-md 
                            p-2 
                            md:w-9 w-5 
                            text-center
                        "
                                name="otp"
                                maxLength={1}
                                value={data}
                                onChange={(e) => handleChange(e.target, index)}
                                onFocus={(e) => e.target.select()}
                                autoFocus={index === 0}
                            />
                        ))}
                    </div>

                    <div className="text-sm text-error-500 text-center break-words">
                        {message}
                    </div>
                </div>

                <div className="flex gap-2 justify-between p-2 flex-wrap">
                    {resend ? (
                        <div className="flex justify-center w-full bg-neutral-50 border rounded-sm border-brand-500 p-2 text-brand-400">
                            <Countdown
                                date={Date.now() + 30000}
                                renderer={renderer}
                            />
                        </div>
                    ) : (
                        <button
                            onClick={() => {
                                setResend(true);
                                retryfunction();
                            }}
                            className="flex justify-center w-full bg-neutral-50 border rounded-sm border-brand-500 p-2 text-brand-400"
                        >
                            Resend
                        </button>
                    )}

                    <button
                        className="text-neutral-50 bg-brand-500 w-full rounded-md p-2"
                        onClick={() => ActionFun()}
                    >
                        Proceed
                    </button>
                </div>
            </div>
        </Modal>

    )
}

export default OtpModal